import React, { forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '80%',
    marginTop: theme.spacing(1),
  },
}));

type Props = React.HTMLProps<HTMLFormElement>;

const Form = forwardRef<HTMLFormElement, Props>(({ children, ...props }) => {
  const classes = useStyles();
  return (
    <form className={classes.root} noValidate {...props}>
      {children}
    </form>
  );
});

export default Form;
